<div *ngIf="loadingMessage" class="pa-spinner-message" translate>{{loadingMessage}}</div>
<div class="pa-progress-circle-spinner" [class.pa-progress-small]="_small" [class.pa-secondary]="color === 'secondary'">
    <div [ngStyle]="backgroundStyle" class="pa-progress-circle-spinner-wrapper">Loading…</div>
</div>
